/* eslint-disable @nx/enforce-module-boundaries */
import { forwardRef, useContext } from 'react';
import { DiskContext } from '../context';
import { Progress } from '@mybridge/ui';
export const MyDiskListingProgress = forwardRef(({ ...props }, ref) => {
  const { filesLoading } = useContext(DiskContext);
  return <Progress opacity={filesLoading ? 1 : 0} size="xs" isIndeterminate />;
});
